<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li><a [routerLink]="'/'">Home</a></li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto">
  <div class="page-sheet w-full max-w-6xl mx-auto">
    <section class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <h2 class="bm-card-title">Stammdaten</h2>
        <table class="bm-table bm-table-xs">
          <tr>
            <td>ID</td>
            <td>{{ project.id }}</td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{{ project.name }}</td>
          </tr>
        </table>
      </div>
    </section>

    <section class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <h2 class="bm-card-title">Workflow Upload</h2>
        <hawk-workflow-upload-applet [projectId]="projectId" />
      </div>
    </section>
  </div>
</div>
